module.exports = __webpack_public_path__ + "static/img/img_about us.e7e8554e.png";